module.exports = __webpack_public_path__ + "static/media/github.fb9a1ab0.png";